import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { Auth } from "../context/AuthContext";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { usuario } = useContext(Auth);

  return (
    <Route
      render={props =>
        usuario ? <Component {...props} /> : <Redirect to="/admin" />
      }
      {...rest}
    />
  );
};

export default ProtectedRoute;
